import { trim } from './trim.esm.js';

var oneOf = function oneOf(layoutNames, layoutName) {
  var _trim2;
  if (!(layoutNames !== null && layoutNames !== void 0 && layoutNames.length)) {
    return false;
  }
  return layoutNames.map(function (l) {
    var _trim;
    return (_trim = trim(l)) === null || _trim === void 0 ? void 0 : _trim.toLowerCase();
  }).includes((_trim2 = trim(layoutName)) === null || _trim2 === void 0 ? void 0 : _trim2.toLowerCase());
};

export { oneOf };
//# sourceMappingURL=one-of.esm.js.map
